import { shallowEqual, useSelector } from 'react-redux'

import { ActionBarRight, ActionBarWrapper } from '@components/UI/Card/Card.styled'
import { IApplicationState } from '@store/index'
import { ISubmission, selectComparisonLink } from '@store/submissions'
import ActionBarIconChat from '../Icon/Chat'
import ActionBarIconCompareSubmission from '../Icon/CompareSubmission/CompareSubmission'
import { ActionBarIconDownload } from '../Icon/Download/Download'
import ActionBarIconLicense from '../Icon/License'
interface IProps {
  campaignId: number
  submission: ISubmission
  hasFeedbackLink: boolean
  showLicenseIcon: boolean
}

const SubmissionCardActionBarContentLicensed: React.FC<IProps> = ({
  campaignId,
  submission,
  hasFeedbackLink,
  showLicenseIcon,
}) => {
  const submissionId = submission.id
  const { hasComparisonLink } = useSelector((state: IApplicationState) => ({
    hasComparisonLink: selectComparisonLink(state, submission.id),
  }), shallowEqual)
  return (
    <ActionBarWrapper justifyEnd>
      <ActionBarRight>
        {hasFeedbackLink && <ActionBarIconChat submission={submission} campaignId={campaignId} />}
        {hasComparisonLink && (
          <ActionBarIconCompareSubmission submissionId={submissionId} campaignId={campaignId} />
        )}
        {showLicenseIcon && <ActionBarIconLicense submissionId={submissionId} />}
        <ActionBarIconDownload submissionId={submissionId} />
      </ActionBarRight>
    </ActionBarWrapper>
  )
}

export default SubmissionCardActionBarContentLicensed
